import type { FC } from "react";
import { routes } from "../../../routes";
import { AlertMessageConditions } from "../types";
import { AlertMessageLink } from "../../../../components/AlertMessage/AlertMessageLink";
import type { AlertMessageLinkWrapperProps } from "./types";

export const DefaultOneSavedPharmacyStaleAccountLink: FC<
  AlertMessageLinkWrapperProps
> = ({ children, ...props }) => (
  <AlertMessageLink
    {...props}
    to={routes.summary.managePharmacies}
    condition={AlertMessageConditions.ONE_SAVED_PHARMACY_STALE_ACCOUNT}
  >
    {children}
  </AlertMessageLink>
);

export const OneSavedPharmacyStaleAccountLink: FC<
  AlertMessageLinkWrapperProps
> = ({ children, alertMessageContext, ...props }) => {
  const hasPlan = !!alertMessageContext.planId;
  const inNetworkPharmacyFinderLink = routes.inNetworkPharmacy.replace(
    ":id",
    alertMessageContext?.planId || ""
  );
  const summaryPageAddPharmaciesLink = hasPlan
    ? inNetworkPharmacyFinderLink
    : routes.pharmacy;
  return (
    <AlertMessageLink
      {...props}
      condition={AlertMessageConditions.ONE_SAVED_PHARMACY_STALE_ACCOUNT}
      to={{
        pathname: alertMessageContext.isFromSummaryPage
          ? summaryPageAddPharmaciesLink
          : inNetworkPharmacyFinderLink,
        search: alertMessageContext?.search,
        state: alertMessageContext?.routerState,
      }}
    >
      {children}
    </AlertMessageLink>
  );
};
